/* tslint:disable */
/* eslint-disable */
export enum PaymentMethodType {
  Card = 'Card',
  ACH = 'ACH',
  PayPal = 'PayPal'
}
